@if (!(isHandsetLandscape$ | async)) {
  <app-shell>
    <router-outlet></router-outlet>
  </app-shell>
} @else {
  <div class="keep-out" fxLayoutAlign="center center">
    <div fxLayoutAlign="start flex-end">
      <mat-icon>warning</mat-icon>
      <span class="message">モバイルでのご利用は縦持ちがおすすめです。</span>
    </div>
  </div>
}

